import React from "react";
import cx from "classnames";
import { Button } from "./Button";

const SecondaryButton = ({ block, ...props }) => {
  return (
    <Button
      className={cx("btn-outline-gold", {
        "w-full": block,
      })}
      {...props}
    />
  );
};

export default SecondaryButton;
